import jwtAxios from "@/util/jwtAxios.js";

const API_URL = import.meta.env.VITE_API_URL;
const API_IMG = import.meta.env.VITE_API_IMGURL;

// 클라이언트 데이터를 서버에 보내기 위한 변환
const prepareProgramData = (data) => ({
    id: data.id || 0,
    type: data.type || "",
    title: data.title || "",
    titleDes: data.titleDes || "",
    mainImage: data.mainImage ? JSON.stringify(data.mainImage) : null,
    content: data.content ? JSON.stringify(data.content) : null,
    link: data.link || null,
});

// 서버 데이터를 클라이언트에서 사용하기 위한 변환
export const parseProgramData = (data) => {
    let mainImage = data.mainImage ? JSON.parse(data.mainImage) : [];
    if (Array.isArray(mainImage)) {
        mainImage = mainImage.map(item => {
            const url = item.url.startsWith(API_IMG) ? item.url : API_IMG + item.url;
            return { ...item, url };
        });
    }

    return {
        id: data.id,
        type: data.type,
        title: data.title,
        titleDes: data.titleDes,
        mainImage: mainImage,
        content: data.content ? JSON.parse(data.content) : null,
        link: data.link,
    };
};

export const fetchProgramData = async (id) => {
    try {
        const response = await jwtAxios.get(`${API_URL}program/${id}`); // 서버에서 데이터 가져오기
        return parseProgramData(response.data.program);
    } catch (error) {
        console.error("Error fetching program data:", error);
    }
}

export const getProgramDatas = async ()=>{
    try{
        return await jwtAxios.get(`${API_URL}program/`);
    } catch (error) {
        console.error("Error getting program data:", error);
    }
}

export const createProgram = async (data) =>{
    try {
        return  await jwtAxios.post(`${API_URL}program/`, prepareProgramData(data));
    } catch (error) {
        console.error("Error creating program data:", error);
        return error;
    }
}

export const updateProgram = async (id, data) =>{
    try {
        return await jwtAxios.put(`${API_URL}program/${id}`, prepareProgramData(data));
    } catch (error) {
        console.error("Error updating program data:", error);
    }
}

export const deleteProgram = async (id) =>{
    try {
        return await jwtAxios.delete(`${API_URL}program/${id}`);

    } catch (error) {
        console.error("Error deleting program data:", error);
    }
}